import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const GeltListCriterios = ({EMPRESA}) => {
  // console.log(EMPRESA)
  //criterioslist
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_ARIZTIA+'criterioslist',{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        EMPRESA: EMPRESA
      })
    })
    let responsito = await query.json();
    // console.log(responsito);
    if(responsito.success){
      resolve(responsito.body)
    }else{
      resolve(null)
    }
  })
}
